import React from "react";
import Error from "@/assets/illustrations/UnitsExceededIllustrationIcon.svg";
import Success from "@/assets/illustrations/SuccessIllustrationIcon.svg";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

interface SuccessErrorScreenProps {
  message: string;
  type: number;
  homeButtonText?: string;
}

const SuccessErrorScreen: React.FC<SuccessErrorScreenProps> = ({
  message,
  type,
  homeButtonText = "Back to Home",
}) => {
  const navigate = useNavigate();

  const getTypeProperties = (type: number) => {
    switch (type) {
      case 1:
        return {
          svg: Success,
          borderColor: "#00C213",
          shadowColor: "#00C213",
          bgColor: "#00C213",
        };
      case 0:
      default:
        return {
          svg: Error,
          borderColor: "#FA0404",
          shadowColor: "#FA0404",
          bgColor: "#FA0404",
        };
    }
  };

  const { svg, borderColor, shadowColor, bgColor } = getTypeProperties(type);

  return (
    <div className="absolute bg-white w-full h-full z-20 flex items-center justify-center px-[24px]">
      <div
        className="relative flex flex-col items-center justify-center w-full min-h-[176px] border rounded-[30px] shadow p-[24px] pt-[58px]"
        style={{
          borderColor: borderColor,
          boxShadow: `0px 2px 0px ${shadowColor}`,
        }}
      >
        <div className="absolute -top-[140px] flex items-center justify-center ">
          <img alt="icon" src={svg} />
        </div>
        <div className="w-full h-full py-6">
          <p className="flex flex-row justify-center items-center">{message}</p>
        </div>
        <Button
          className="rounded-[10px] w-full text-[14px] h-[47px]"
          style={{ backgroundColor: bgColor }}
          onClick={() => navigate("/home")}
        >
          {homeButtonText}
        </Button>
      </div>
    </div>
  );
};

export default SuccessErrorScreen;
